module.exports = __webpack_public_path__ + "img/hero-medusa-oni-2.fc37b5c5.png";